import { render, staticRenderFns } from "./purchases.vue?vue&type=template&id=0cf29d97&scoped=true"
import script from "./purchases.vue?vue&type=script&lang=js"
export * from "./purchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf29d97",
  null
  
)

export default component.exports